import { getSearchMusic } from '@/request/api/home.js';
import SongList from '@/components/MusicListItem/SongList.vue';
export default {
  data() {
    return {
      keywordsList: [],
      searchKey: '',
      searchSongList: []
    };
  },

  components: {
    SongList
  },

  mounted() {
    this.keywordsList = JSON.parse(localStorage.getItem("keywordsList")) || [];
  },

  methods: {
    saveHistory: async function () {
      if (this.searchKey.trim() == '') return;
      this.keywordsList.unshift(this.searchKey); //去重

      this.keywordsList = [...new Set(this.keywordsList)]; //固定数量

      if (this.keywordsList.length > 10) this.keywordsList.splice(this.keywordsList.length - 1, 1);
      localStorage.setItem("keywordsList", JSON.stringify(this.keywordsList));
      let {
        data: res
      } = await getSearchMusic(this.searchKey);
      this.searchSongList = res.result.songs;
      console.log(res);
      this.searchKey = '';
    },

    deleteHistory() {
      localStorage.removeItem("keywordsList");
      this.keywordsList = [];
    },

    searchHistory: async function (value) {
      let {
        data: res
      } = await getSearchMusic(value);
      this.searchSongList = res.result.songs;
    }
  }
};